<div class="categories block">
  <div class="heading heading_standard heading_centered">
    Popular categories
  </div>
  <div class="categories__row">
    @for (category of categories$ | async; track category.id) {
      <a [appCategory]="category.name" class="category border-radius">
        @if (category.image) {
          <img
            [src]="category.image.url"
            [width]="category.image.width"
            [height]="category.image.height"
            [alt]="category.name"
            class="category__image"
          />
        }
        <div class="category__info">
          <div class="heading heading_standard">{{ category.name }}</div>
          <span>{{ category.count }} results</span>
        </div>
      </a>
    }
  </div>
</div>
